import type { ReactNode } from "react";
import {
  Tooltip as AriaTooltip,
  type TooltipProps as AriaTooltipProps,
  TooltipTrigger as AriaTooltipTrigger,
} from "react-aria-components";
import { cx } from "@/lib/cx";

export function Tooltip({
  className,
  offset = 6,
  ...props
}: Omit<AriaTooltipProps, "className"> & { className?: string }) {
  return (
    <AriaTooltip
      offset={offset}
      className={cx(
        "popover-anim z-[60] flex max-w-72 items-center gap-2 rounded-control bg-tooltip-bg px-2 py-1 text-xs font-medium text-tooltip-fg shadow-md",
        className,
      )}
      {...props}
    />
  );
}

/**
 * Wrap a single focusable element. Tooltips never carry essential information: they repeat the
 * accessible name or add a hint, and appear on keyboard focus as well as hover.
 */
export function Tip({
  label,
  children,
  delay = 500,
  placement,
}: {
  label: ReactNode;
  children: ReactNode;
  delay?: number;
  placement?: AriaTooltipProps["placement"];
}) {
  return (
    <AriaTooltipTrigger delay={delay} closeDelay={0}>
      {children}
      <Tooltip placement={placement}>{label}</Tooltip>
    </AriaTooltipTrigger>
  );
}
